"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChannelsList = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ExpandMore = _interopRequireDefault(require("@mui/icons-material/ExpandMore"));
var _material = require("@mui/material");
var _useGetChannels2 = require("@/api/useGetChannels");
var _useGetTeams2 = require("@/api/useGetTeams");
var _TeamsAndChannelsContext = require("@/context/TeamsAndChannelsContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var ChannelsList = exports.ChannelsList = function ChannelsList(_ref) {
  var _expandedTeam$id;
  var onSelectChannel = _ref.onSelectChannel;
  var _useTeamsAndChannels = (0, _TeamsAndChannelsContext.useTeamsAndChannels)(),
    setTeamsAndChannels = _useTeamsAndChannels.setTeamsAndChannels,
    msalConfig = _useTeamsAndChannels.msalConfig,
    teamsAndChannels = _useTeamsAndChannels.teamsAndChannels;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    expandedTeam = _useState2[0],
    setExpandedTeam = _useState2[1];
  var _useGetTeams = (0, _useGetTeams2.useGetTeams)(msalConfig.backend_uri),
    teams = _useGetTeams.data,
    teamsLoading = _useGetTeams.isLoading;
  var _useGetChannels = (0, _useGetChannels2.useGetChannels)(msalConfig.backend_uri, (_expandedTeam$id = expandedTeam === null || expandedTeam === void 0 ? void 0 : expandedTeam.id) !== null && _expandedTeam$id !== void 0 ? _expandedTeam$id : "", {
      enabled: !!(expandedTeam !== null && expandedTeam !== void 0 && expandedTeam.id)
    }),
    channels = _useGetChannels.data,
    channelLoading = _useGetChannels.isLoading;
  (0, _react.useEffect)(function () {
    if (teams) {
      setTeamsAndChannels(teams);
    }
  }, [teams, setTeamsAndChannels]);
  (0, _react.useEffect)(function () {
    if (channels && expandedTeam) {
      var updatedTeams = teamsAndChannels === null || teamsAndChannels === void 0 ? void 0 : teamsAndChannels.map(function (team) {
        return team.id === expandedTeam.id ? _objectSpread(_objectSpread({}, team), {}, {
          channels: channels
        }) : _objectSpread({}, team);
      });
      setTeamsAndChannels(updatedTeams || []);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channels]);
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedIndex = _useState4[0],
    setSelectedIndex = _useState4[1];
  var handleListItemClick = function handleListItemClick(channel) {
    setSelectedIndex(channel.id);
    onSelectChannel({
      drive_id: channel.driveId,
      item_id: channel.folderId,
      channelName: channel.displayName,
      teamName: (expandedTeam === null || expandedTeam === void 0 ? void 0 : expandedTeam.displayName) || ""
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    sx: {
      border: "1px solid #D0D0CE",
      backgroundColor: "#F5F5F5",
      height: "calc(100% - 68px)",
      maxHeight: "calc(100% - 68px)",
      padding: "24px",
      overflowY: "auto"
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    fontWeight: "bold"
  }, "Teams and Channels"), teamsLoading && /*#__PURE__*/_react["default"].createElement(_material.Skeleton, {
    "data-testid": "teams_skeleton",
    width: 150,
    height: 30
  }), teamsAndChannels && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    height: "95%",
    sx: {
      overflowY: "auto",
      width: "100%"
    }
  }, teamsAndChannels.map(function (team) {
    return /*#__PURE__*/_react["default"].createElement(_material.Accordion, {
      disableGutters: true,
      elevation: 0,
      square: true,
      sx: {
        backgroundColor: "transparent",
        boxShadow: "none",
        width: "100%"
      },
      key: team.id,
      onChange: function onChange() {
        if (team.channels.length === 0) {
          setExpandedTeam(team);
        }
      }
    }, /*#__PURE__*/_react["default"].createElement(_material.AccordionSummary, {
      sx: {
        padding: 0,
        minHeight: "40px",
        flexDirection: "row-reverse",
        "& .MuiAccordionSummary-expandIconWrapper": {
          marginRight: "auto",
          transform: "none"
        }
      },
      expandIcon: channelLoading && (expandedTeam === null || expandedTeam === void 0 ? void 0 : expandedTeam.id) === team.id ? /*#__PURE__*/_react["default"].createElement(_material.CircularProgress, {
        size: 14
      }) : /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null)
    }, /*#__PURE__*/_react["default"].createElement(_material.Typography, null, team.displayName)), /*#__PURE__*/_react["default"].createElement(_material.AccordionDetails, {
      sx: {
        padding: 0
      }
    }, /*#__PURE__*/_react["default"].createElement(_material.List, {
      sx: {
        width: "100%"
      }
    }, team.channels.map(function (channel) {
      return /*#__PURE__*/_react["default"].createElement(_material.ListItem, {
        disablePadding: true,
        sx: {
          ppadingTop: "5px",
          paddingLeft: "25px"
        },
        key: channel.id
      }, /*#__PURE__*/_react["default"].createElement(_material.ListItemButton, {
        sx: {
          padding: 0,
          backgroundColor: selectedIndex === channel.id ? "#FFFFFF !important" : "auto"
        },
        selected: selectedIndex === channel.id,
        onClick: function onClick() {
          return handleListItemClick(channel);
        }
      }, /*#__PURE__*/_react["default"].createElement(_material.ListItemText, {
        primary: /*#__PURE__*/_react["default"].createElement(_material.Typography, {
          fontWeight: selectedIndex === channel.id ? "bold" : "normal"
        }, channel.displayName)
      })));
    }))));
  })));
};